// http://res.plazaro.loc/clyxut/cs/get-database-data?hotelId=clyxut&arrival=2018-03-19+00%3A00%3A00&departure=2018-03-20+00%3A00%3A00&stayType=vacation&all=0
import queryString from 'query-string';
import moment from 'moment';

import { DATE_FORMAT } from './constants';
import { jsonToUrlEncoded } from './utils';
import BedConfig from './enums/BedConfig';

const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';

export async function fetchInitData(state) {
	const { hotelId, lang, theme, apiOrigin } = state.app;
	const params = { theme };

	try {
		const response = await fetch(`${apiOrigin}/${hotelId}/${lang}/data?${queryString.stringify(params)}`);
		return await response.json();

	} catch (e) {
		throw(e);
	}
}

export async function fetchRoomTypesAvailabilitiesData(state, from, to) {
	const { hotelId, lang, apiOrigin } = state.app;

	const params = {
		from: from.format(dateTimeFormat),
		to: to.format(dateTimeFormat),
	};

	const response = await fetch(`${apiOrigin}/${hotelId}/${lang}/availabilities?${queryString.stringify(params)}`);
	return await response.json();
}

export async function fetchReservationData(state, arrival = null, departure = null) {
	const { hotelId, lang, apiOrigin, all } = state.app;
	const formValues = state.form.bookingForm.values;

	if (!arrival) arrival = formValues.arrival;
	if (!departure) departure = formValues.departure;

	const params = {
		arrival: moment(arrival, DATE_FORMAT).format(dateTimeFormat),
		departure: moment(departure, DATE_FORMAT).format(dateTimeFormat),
		stayType: formValues.stayType,
		all,
	};

	const response = await fetch(`${apiOrigin}/${hotelId}/${lang}/rooms?${queryString.stringify(params)}`);
	return await response.json();
}

export async function fetchAresData(state) {
	const { hotelId, lang, apiOrigin } = state.app;
	const formValues = state.form.bookingForm.values;

	const params = {
		do: 'getAresData',
		ico: formValues.companyIc || '',
	};

	const response = await fetch(`${apiOrigin}/${hotelId}/${lang}/?${queryString.stringify(params)}`, {
		method: 'POST',
	});

	return await response.json();
}

export async function submitReservation(state, recaptchaToken) {
	const { hotelId, lang, apiOrigin, advancePaymentPercentage, isAdvancePaymentRequired  } = state.app;
	const formValues = state.form.bookingForm.values;
	const allRoomTypesIds = Object.keys(state.app.apiRoomsResponse.roomTypes).map(id => id.startsWith('_') ? id : parseInt(id, 10));

	let roomCount = 0;
	let roomTypeIndex = 1;
	let roomType = {};

	for (let roomTypeId in formValues.rooms) {
		if (!formValues.rooms.hasOwnProperty(roomTypeId)) continue;

		const rooms = formValues.rooms[roomTypeId];

		roomTypeId = roomTypeId.startsWith('_') ? roomTypeId : parseInt(roomTypeId, 10);
		for (let room of rooms) {
			roomType[roomTypeIndex] = {};
			roomType[roomTypeIndex]['guest'] = room.guestTypes;
			roomType[roomTypeIndex]['item'] = {};

			for (let allRoomTypesId of allRoomTypesIds) {
				roomType[roomTypeIndex]['item'][allRoomTypesId] = {};
				roomType[roomTypeIndex]['item'][allRoomTypesId]['count'] = allRoomTypesId === roomTypeId ? 1 : 0;
				roomType[roomTypeIndex]['item'][allRoomTypesId]['doubleBed'] = BedConfig.getApiValue(room.bedConfig);
				roomType[roomTypeIndex]['item'][allRoomTypesId]['extraFees'] = room.extraFees !== undefined
					? Object.entries(room.extraFees).filter(([_, selected]) => selected).map(([extraFeeId]) => extraFeeId)
					: [];
			}

			roomCount++;
			roomTypeIndex++;
		}
	}

	const body = {
		arrival: formValues.arrival,
		departure: formValues.departure,
		roomtype: roomType,
		roomcount: roomCount,
		stayType: formValues.stayType,
		boardBase: formValues.boardBase,
		firstname: formValues.firstName || '',
		surname: formValues.lastName || '',
		email: formValues.email || '',
		phone: formValues.phone || '',
		street: formValues.street || '',
		city: formValues.city || '',
		zip: formValues.postCode || '',
		note: formValues.note || '',
		company: formValues.isCompany ? 'on' : null,
		company_ino: formValues.companyIc || '',
		company_name: formValues.companyName || '',
		company_vatin: formValues.companyDic || '',
		company_street: formValues.companyStreet || '',
		company_zip: formValues.companyCity || '',
		company_city: formValues.companyPostCode || '',
		company_country_id: formValues.companyCountry || '',
		terms: formValues.agree ? 'on' : '',
		stornoInsurance: formValues.stornoInsurance ? 'on' : '',
		hotelId,
		token: recaptchaToken,
	};

	if (formValues.paymentMethod) {
		body.paymentInstrument = formValues.paymentMethod.toLowerCase();
		if (isAdvancePaymentRequired || (advancePaymentPercentage < 100 && formValues.advancePaymentOnly)) {
			body.advancePaymentPercentage = advancePaymentPercentage;
		}
	}

	const response = await fetch(`${apiOrigin}/${hotelId}/${lang}/submit-reservation?version=2`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
		},
		body: jsonToUrlEncoded(body)
	});

	return await response.json();
}

function arrayBufferToBase64(buffer) {
	var binary = '';
	var bytes = [].slice.call(new Uint8Array(buffer));

	bytes.forEach((b) => binary += String.fromCharCode(b));

	return window.btoa(binary);
};

export async function fetchImage(state, url) {
	const response = await fetch(url);
	const buffer = await response.arrayBuffer();

	const base64Flag = 'data:image/jpeg;base64,';
	const imageStr = arrayBufferToBase64(buffer);

	return base64Flag + imageStr;
}


// WEBPACK FOOTER //
// ./src/api.js